import type { RootState } from '@/common/redux/store';
import { useAppSelector } from '@/common/redux/store';

// Mirrors mobile's `AppBootGate` (see apps/mobile/src/common/redux/app-boot-gate.tsx): the root
// persistor covers `preferences`/`cookieConsent` (its whitelist), while `auth` and
// `impersonation` are nested `persistReducer`s with their own storage (localStorage/sessionStorage)
// and rehydrate on their own timeline — see store.ts. All three must report `rehydrated` before
// consumers (AuthGuard, AuthLayout) can trust `state.auth.user`.
const selectIsStoreHydrated = (state: RootState): boolean =>
  Boolean(state._persist?.rehydrated && state.auth._persist?.rehydrated && state.impersonation._persist?.rehydrated);

export function useStoreHydration(): boolean {
  return useAppSelector(selectIsStoreHydrated);
}
